import {
  Chip,
  Collapse,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import CustomNoRowsOverlay from "../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import MainCard from "../../../../components/Maincard";
import SearchButton from "../../../newComponent/NewButtonComp/SearchButton";
import CustomTextFieldComp from "../../../newComponent/customTextFieldComp";
import CustomAutocompleteComp from "../../../newComponent/AutocompleteComp";
import SearchTextFieldComp from "../../../newComponent/newtextfieldComp/SearchTextFieldComp";
import CustomSnackbar from "../../../components/ui-component/snackbar/CustomSnackbar";
import { useGetTokenOrLogout } from "../../../../utils/token";
import { useNavigate } from "react-router-dom";
import LoaderComp from "../../../newComponent/LoaderComp/Loader";
import CustomPopup from "../../../../components/CustomPopup";
import { CSVExport } from "../../../components/ui-component/table/CSVExport";
import MetaHyperlink from "./MetaHyperLink";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;
export default function MetaUserWiseReport({ open, isDownloadAccess }) {  
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const getTokenOrLogout = useGetTokenOrLogout();
  const navigate = useNavigate();
  const [subServiceList, setSubsubServiceList] = useState([]);
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setTodate] = useState(null);

  const [recycleBylist, setRecyCleByList] = useState([]);
  const [recycleByName, setRecycleByName] = useState([]);
  const [recycledData, setRecyCleData] = useState([]);
  const [SearchData, setSearchData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [filterType, setFilterType] = useState("today");
  const [loading, setLoading] = useState(false);
  const [detailesLoading, setDetailsLoading] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);
  const [detailsData, setDetailsData] = useState([]);
  const [rowData, setRowData] = useState({});
  const [exportData, setExportData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);
  const [snackbarMessage, setSnackbarMessage] = React.useState("");
  const [snackbarSeverity, setSnackbarSeverity] = React.useState("success");

  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `${API_ENDPOINT}route2.0/getadvisors/${userId}`
        );
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setRecyCleByList(sortedData);
          setRecycleByName(sortedData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allResycleByList = [{ first_name: "Select All" }, ...recycleBylist];

  const handleChangeRecycleBy = (event, value) => {
    if (value.some((option) => option.first_name === "Select All")) {
      setRecycleByName(recycleBylist);
    } else {
      setRecycleByName(value);
    }
  };

  const handleFilterChange = (event) => {
    setFilterType(event.target.value);
  };

  const handleSearchData = async (event) => {
    setLoading(true);

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      assign_to: ["advisor"].includes(userRole)
        ? null
        : recycleByName.map((i) => i.user_id),
      filter: filterType,
      user_id: parseInt(userId),
      meta_from_date: fromDate || null,
      meta_to_date: toDate || null,
    };

    try {
      const response = await fetch(`${API_ENDPOINT}route2.0/meta-user-report`, {
        method: "POST",
        headers,
        body: JSON.stringify(requestData),
      });

      const result = await response.json();
      if (response.ok) {
        setLoading(false);

        setRecyCleData(result);
        setSearchData(result);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("/page401");
      } else if (response.status === 403) {
        navigate("/page403");
      } else if (response.status === 400) {
        setLoading(false);
        showSnackbar(result.message, "error");
        setRecyCleData([]);
      } else {
        navigate("/page500");
      }
    } catch {
      navigate("/page500");
    }
  };

  useEffect(() => {
    handleSearchData();
  }, []);

  const columns = [
    {
      field: "lead_owner",
      headerName: "Lead Owner",
      flex: 1,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      valueGetter: (params) =>
        `${params.row?.first_name || ""} ${params.row?.last_name || ""}`,
      renderCell: (params) => {
             const isLastRow=params?.row?.first_name==="Total"
        return (
          
        <div  style={{
              color: isLastRow ? "black" : "",

              fontWeight: isLastRow ? 700 : 500,
            }}>
          {params.row?.first_name} {params.row?.last_name}{" "}
        </div>
      )},
    },
    {
      field: "recycled_enq",
      headerName: "Total Enquiry",
      flex: 1,
      headerClassName: "header-cell",
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
         const isLastRow=params?.row?.first_name==="Total"
        return ( 
        <div
        style={{
              color: isLastRow ? "black" : "blue",
              cursor: "pointer",
              fontWeight: isLastRow ? 700 : 500,
            }}
          onClick={() => !isLastRow ? handleSearchDetailsData(params?.row) :undefined}
        >
          {params.row?.meta_enq}
        </div>
      ) },
    },
  ];

  const handleSearchByName = (e) => {
    const value = e.target.value.toLowerCase().replace(/\s+/g, ""); // Normalize search value (lowercase and remove spaces)

    let filteredData1 = SearchData.filter((data) => {
      // Check each field for a match with the search value
      const fieldsToSearch = [
        `${data?.first_name || ""} ${data?.last_name || ""}`,
        `${data?.recycled_enq || ""}`,
      ];

      // Check if any of the fields contain the search value
      return fieldsToSearch.some((field) =>
        field.toLowerCase().replace(/\s+/g, "").includes(value)
      );
    });

    setRecyCleData(filteredData1); // Update the filtered data
  };

  // Details Data
  const handleOpenPopup = (rowData) => {
    setDetailsOpen(true);
    setRowData(rowData);
  };
  const handleClosePopup = () => {
    setDetailsOpen(false);
  };

  const handleSearchDetailsData = async (rowData) => {
   

    const token = getTokenOrLogout();
    if (!token) return;
    let headers = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json", // Make sure to keep the content type
    };
    const requestData = {
      assign_to: rowData?.user_id,
      filter: filterType,
      user_id: parseInt(userId),
      meta_from_date: fromDate || null,
      meta_to_date: toDate || null,
    };

    try {
      setDetailsLoading(true)
      const response = await fetch(
        `${API_ENDPOINT}route2.0/meta-user-report-with-detail`,
        {
          method: "POST",
          headers,
          body: JSON.stringify(requestData),
        }
      );

      const result = await response.json();
      if (response.ok) {
        setDetailsLoading(false);

        setDetailsData(result);
        setSearchData(result);
        handleOpenPopup(rowData);
      } else if (response.status === 404) {
        navigate("/page404");
      } else if (response.status === 401) {
        navigate("Unknown User", "error");
      } else if (response.status === 403) {
        navigate("Unathorized User", "error");
      } else if (response.status === 400) {
        setDetailsLoading(false);
        showSnackbar(result.message, "error");
        setDetailsData([]);
      } else {
        showSnackbar("Server Error", "error");
        setDetailsLoading(false);
      }
    } catch {
      showSnackbar("Server Error", "error");
      setDetailsLoading(false);
    }
  };

  // Export Data

  useEffect(() => {
    const exportData = recycledData.map((row) => ({
      lead_owner: `${row?.first_name || ""}  ${row?.last_name || ""}`,
      recycle_enquiry: row?.recycled_enq,
    }));
    setExportData(exportData);
  }, [recycledData]);

  return (
    <>
      <LoaderComp isLoading={loading || detailesLoading} />
      <Grid container spacing={2}>
        {/* Filter comp */}
        <Grid item xs={12}>
          <Collapse in={open}>
            <MainCard>
              <Grid container spacing={2}>
                {[
                  "center_admin",
                  "data_entry",
                  "admin",
                  "team_lead",
                  "junior_data_entry",
                ].includes(userRole) && (
                  <Grid item xs={12} lg={3} md={4} sm={6}>
                    <Typography variant="h6">Lead Owner</Typography>

                    <CustomAutocompleteComp
                      multiple
                      limitTags={1}
                      value={recycleByName}
                      options={allResycleByList}
                      onChange={handleChangeRecycleBy}
                      getOptionLabel={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                      tooltipContent={(option) =>
                        `${option.first_name ? option.first_name : ""} ${
                          option.last_name ? option.last_name : ""
                        }`
                      }
                    />
                  </Grid>
                )}

                <Grid item xs={12} lg={2} md={4} sm={6}>
                  <Typography variant="h6">Enquiry Created Date Filter</Typography>
                  <Select
                    value={filterType}
                    onChange={handleFilterChange}
                    fullWidth
                    style={{ borderRadius: "10px" }}
                    size="medium"
                  >
                    <MenuItem value="today">Today</MenuItem>
                    <MenuItem value="currentweek">This Week</MenuItem>
                    <MenuItem value="currentmonth">This Month</MenuItem>
                    <MenuItem value="custom">Custom</MenuItem>
                  </Select>
                </Grid>

                {filterType === "custom" && (
                  <>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6"> Enquiry Created From Date</Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={fromDate}
                        onChange={(e) => setFromDate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                    <Grid item xs={12} lg={2} md={4} sm={6}>
                      <Typography variant="h6"> Enquiry Created From Date</Typography>
                      <CustomTextFieldComp
                        size="normal"
                        fullWidth
                        type="date"
                        value={toDate}
                        onChange={(e) => setTodate(e.target.value)}
                        InputProps={{
                          style: { borderRadius: "10px" },
                        }}
                      />
                    </Grid>
                  </>
                )}

                <Grid item xs={12} lg={2}>
                  <Typography sx={{ visibility: "hidden" }}>Hidden </Typography>
                  <SearchButton showIcon={true} onClick={handleSearchData} />
                </Grid>
              </Grid>
            </MainCard>
          </Collapse>
        </Grid>

        <Grid item xs={12}>
          <MainCard>
            <Grid container spacing={2}>
              <Grid
                item
                xs={12}
                container
                justifyContent="end"
                alignItems="center"
                gap={1}
              >
                <SearchTextFieldComp onChange={handleSearchByName} />
                {isDownloadAccess && (
                  <CSVExport
                    data={exportData}
                    filename="recycle-enquiry-report.csv"
                  />
                )}
              </Grid>
              <Grid item xs={12}>
                <DataGrid
                  rows={recycledData}
                  columns={columns}
                  autoHeight
                  slots={{
                    noRowsOverlay: CustomNoRowsOverlay,
                  }}
                  initialState={{
                    pagination: {
                      paginationModel: {
                        pageSize: 25,
                      },
                    },
                  }}
                  pageSizeOptions={[25, 50, 100]}
                  disableRowSelectionOnClick
                />
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
      </Grid>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

      <CustomPopup
              open={detailsOpen}
              onClose={handleClosePopup}
              component={
                <MetaHyperlink
                  detailsData={detailsData}
                  rowData={rowData}
                  filterType={filterType}
                  fromDate={fromDate}
                  toDate={toDate}
                  userWise={true}
                  isDownloadAccess={isDownloadAccess}
                />
              }
              title="Meta Enquiry Details"
              maxWidth="lg"
              showDivider={true}
            />
    </>
  );
}
